import React, { useContext, useEffect, useMemo } from "react";
import { Link, NavLink } from "react-router-dom";
import "./Header.scss";
// blocks

import logo from "../../../img/solimat-logo.svg"



const HeaderWithoutAuthorization =() => {

 
  return (
    
      <header className="header-new-block">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="header-new-content">
                <div className="logo-new-block">
                  <div className="logo-new-container">
                    <img src={logo} className="logo-new" alt="solimat" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
  
  );
};

export default HeaderWithoutAuthorization;
